import { render } from "./ValueYourTrade.vue?vue&type=template&id=1dbdf926&lang=true"
import script from "./ValueYourTrade.vue?vue&type=script&lang=js"
export * from "./ValueYourTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/ValueYourTrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dbdf926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dbdf926', __exports__)) {
    api.reload('1dbdf926', __exports__)
  }
  
  module.hot.accept("./ValueYourTrade.vue?vue&type=template&id=1dbdf926&lang=true", () => {
    api.rerender('1dbdf926', render)
  })

}


export default __exports__